import { render, staticRenderFns } from "./CmsCustomButtonWrapper.vue?vue&type=template&id=42a0ced6&"
import script from "./CmsCustomButtonWrapper.vue?vue&type=script&lang=ts&"
export * from "./CmsCustomButtonWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports